<template>
  <div>
    <v-card elevation="6">
      <div class="pa-3">
        <div class="grid_select">
          <div class="grid_header_sell">
            <div class="mx-auto">
              <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_cost" :src="img_cost"/>
            </div>
            <div class="pt-3 pl-2" style="font-size: 26px"><b>กำไรต่อเดือน</b></div>
          </div>
          <div class="ma-2">
            <v-select color="#86bc3a" @input="dump_data_select()" :items="year_arr" item-text="show_year" item-value="year_eng" v-model="selected_year_cost" prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ." hide-details="auto" outlined></v-select>
          </div>
        </div>
        <div style="height: 40vh !important">
          <canvas id="myChartCost"></canvas>
        </div>
      </div>
    </v-card>
    <div class="mt-3 mb-3">
      <v-card elevation="6" style="cursor:pointer;" @click="$router.push('/stock/promotion_stock/promotionexp')">
        <div class="pa-3">
          <div class="grid_header_dairy">
            <div class="mx-auto">
              <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_promotion" :src="img_promotion"/>
            </div>
            <div class="pt-3 pl-2" style="font-size: 26px"><b>โปรโมชั่นใกล้สิ้นสุด</b></div>
          </div>
          <div class="mt-2">
            <div><b>โปรโมชั่นลดล้างสต๊อก</b></div>
            <div v-if="expireds_list.length > 0" class="pa-2">
              <div class="grid_flex mb-1" v-for="(data, index) in expireds_list" :key="index">
                <div>{{ data.promotion_name }}</div>
                <div class="text-sm-right text-md-right text-lg-right text-xl-right">วันที่สิ้นสุด {{ data.end_date }}</div>
              </div>
            </div>
            <div v-else class="pa-2">
              <div class="grid_flex mb-1">-</div>
            </div>
          </div>
          <div class="mt-2">
            <div><b>โปรโมชั่นชุดเซ็ต</b></div>
            <div v-if="mains_list.length > 0" class="pa-2">
              <div class="grid_flex" v-for="(data, index) in mains_list" :key="index">
                <div>{{ data.promotion_name }}</div>
                <div class="text-sm-right text-md-right text-lg-right text-xl-right">วันที่สิ้นสุด {{ data.end_date }}</div>
              </div>
            </div>
            <div v-else class="pa-2">
              <div class="grid_flex mb-1">-</div>
            </div>
          </div>
          <div class="mt-2">
            <div><b>โปรโมชั่นชุดคละ</b></div>
            <div v-if="set_list.length > 0" class="pa-2">
              <div class="grid_flex" v-for="(data, index) in set_list" :key="index">
                <div>{{ data.promotion_name }}</div>
                <div class="text-sm-right text-md-right text-lg-right text-xl-right">วันที่สิ้นสุด {{ data.end_date }}</div>
              </div>
            </div>
            <div v-else class="pa-2">
              <div class="grid_flex mb-1">-</div>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import img_cost from "@/assets/financial-profit_refund.png";
import Chart from "chart.js/auto";
import img_promotion from "@/assets/bell_refund.png";
import {HTTP} from "@/axios";

export default {
  name: "Cost_per_month",
  data() {
    return {
      img_cost: img_cost,
      img_promotion: img_promotion,
      selected_year_cost: null,
      year_arr: [],
      graph_list_cost: [],
      graph_list_profit: [],
      myChartCost: null,
      year: [
        {id: 1, name: 'ปี 2565'},
        {id: 2, name: 'ปี 2564'},
        {id: 3, name: 'ปี 2563'},
        {id: 4, name: 'ปี 2562'},
        {id: 5, name: 'ปี 2561'},
      ],
      expireds_list: [],
      mains_list: [],
      set_list: [],
    }
  },
  methods: {
    get_data() {
      this.expireds_list = []
      this.mains_list = []
      HTTP.post('/dashboards/promotions')
          .then((res) => {
            if(res.data.success === true) {
              res.data.object.expireds.forEach((data) => {
                this.expireds_list.push({
                  promotion_name: data.promotion_name,
                  end_date: data.end_date,
                })
              })
              res.data.object.mains.forEach((data) => {
                this.mains_list.push({
                  promotion_name: data.promotion_name,
                  end_date: data.end_date,
                })
              })
              res.data.object.sets.forEach((data) => {
                this.set_list.push({
                  promotion_name: data.promotion_name,
                  end_date: data.end_date,
                })
              })
            }
          })
    },
    async year_function() {
      this.year_arr = []
      let arr_year = [0, 1, 2]
      let count_year = new Date()
      let full_year = count_year.getFullYear()
      for (let i = 0; i < arr_year.length; i++) {
        let count_th = ((full_year + 543) - i);
        let count_eng = ((full_year) - i);
        this.year_arr.push({
          id: i,
          year_th: count_th,
          year_eng: count_eng,
          show_year: 'ปี ' + count_th,
        })
      }
      this.selected_year_cost = this.year_arr[0].year_eng
      await this.dump_data_select()
    },
    async dump_data_select() {
      this.graph_list_cost = []
      this.graph_list_profit = []
      await HTTP.post('/dashboards/costorprofit', {
        year: this.selected_year_cost
      }).then((res) => {
        if (res.data.success === true) {
          res.data.object.totalcost.forEach((data) => {
            // this.graph_list_cost.push(parseFloat(data.cost))
            this.graph_list_profit.push(parseFloat(data.profit))
          })
          if (this.myChartCost !== null) {
            this.myChartCost.destroy()
          }
          this.chart_cost()
        }
      })
    },
    chart_cost() {
      let data = {
        labels: this.$store.state.monthThai,
        datasets: [
          // {
          //   label: 'ต้นทุน',
          //   data: this.graph_list_cost,
          //   borderColor: '#939590',
          //   backgroundColor: '#939590',
          //   fill: false
          // },
          {
            label: 'กำไร',
            data: this.graph_list_profit,
            borderColor: '#8CC63E',
            backgroundColor: '#8CC63E',
            fill: false
          },
        ]
      }
      let config = {
        type: 'line',
        data: data,
        options: {
          responsive: true,
          maintainAspectRatio: false,
        }
      }
      const ctx = document.getElementById('myChartCost').getContext('2d');
      this.myChartCost = new Chart(ctx, config)
    },
  },
  mounted() {
    this.get_data()
    this.year_function()
  }
}
</script>

<style scoped>
.grid_select {
  display: grid;
  grid-template-columns: 80% 20%;
}
.grid_header_sell {
  display: grid;
  grid-template-columns: 10% 90%;
}
.grid_header_dairy {
  display: grid;
  grid-template-columns: 8% 92%;
}
.grid_flex {
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 1180px) {
  .grid_select {
    display: grid;
    grid-template-columns: 70% 30%;
  }
  .grid_header_sell {
    display: grid;
    grid-template-columns: 22% 78%;
  }
  .grid_header_dairy {
    display: grid;
    grid-template-columns: 15% 85%;
  }
  .grid_flex {
    display: grid;
    grid-template-columns: 70% 30%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_select {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_header_sell {
    display: grid;
    grid-template-columns: 25% 75%;
  }
  .grid_header_dairy {
    display: grid;
    grid-template-columns: 20% 80%;
  }
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
